module.exports = __webpack_public_path__ + "6bcac744f9a7f47e5b7fc3d8e87005f7.svg";